import { appRoleGuard, articleRoleGuard } from "./01_core/auth/role-guards";
import { Routes } from "./01_core/services/mdi-router.service";

export default <Routes>[
  {
    path: 'home',
    loadComponent: async() => (await import('./07_feature/dashboard/dashboard.component')).DashboardComponent,
    canActivate: [appRoleGuard],
  },
  {
    path: '',
    loadComponent: async() => (await import('./07_feature/dashboard/dashboard.component')).DashboardComponent,
    canActivate: [appRoleGuard],
  },
  {
    path: 'customer',
    canActivate: [appRoleGuard],
    canActivateChild: [appRoleGuard],
    children: [
      {
        path: '',
        loadComponent: async () => (await import('./07_feature/customer/customers.component')).CustomersComponent,
      },
      {
        path: ':customerID',
        loadComponent: async () => (await import('./07_feature/customer/customer-layout/customer-layout.component')).CustomerLayoutComponent,
        children: [
          {
            path: '',
            loadComponent: async () => (await import('./07_feature/customer/customer-overview/customer-overview.component')).CustomerOverviewComponent,
          },
          { path: 'basedata', loadComponent: async () => (await import('./07_feature/customer/customer-basedata/customer-basedata.component')).CustomerBaseDataComponent, },
          { path: 'account', loadComponent: async () => (await import('./07_feature/customer/customer-account/customer-account.component')).CustomerAccountComponent, },
          { path: 'document', loadComponent: async () => (await import('./07_feature/customer/customer-document/customer-document.component')).CustomerDocumentComponent, },
          { path: 'revenue', loadComponent: async () => (await import('./07_feature/customer/customer-revenue/customer-revenue.component')).CustomerRevenueComponent, },
          { path: 'contact', loadComponent: async () => (await import('./07_feature/customer/customer-contact/customer-contact.component')).CustomerContactComponent, },
          { path: 'order', loadComponent: async () => (await import('./07_feature/customer/customer-manufacturing-order/customer-manufacturing-order.component')).CustomerManufacturingOrderComponent, },
          { path: 'article', loadComponent: async () => (await import('./07_feature/customer/customer-article/customer-article.component')).CustomerArticleComponent, },
          { path: 'comment', loadComponent: async () => (await import('./07_feature/customer/customer-comment/customer-comment.component')).CustomerCommentComponent, },
        ],
      },
    ],
  },
  {
    path: 'order',
    canActivate: [appRoleGuard],
    canActivateChild: [appRoleGuard],
    children: [
      {
        path: '',
        loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order.component')).ManufacturingOrderComponent,
      },
      {
        path: ':orderID',
        loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-layout/manufacturing-order-layout.component')).ManufacturingOrderLayoutComponent,
        children: [
          {
            path: '',
            loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-detail/manufacturing-order-detail.component')).ManufacturingOrderDetailComponent,
          },
          { path: 'document', loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-document/manufacturing-order-document.component')).ManufacturingOrderDocumentComponent, },
          { path: 'article', loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-article/manufacturing-order-article.component')).ManufacturingOrderArticleComponent, },
          { path: 'calculation', loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-calculation/manufacturing-order-calculation.component')).ManufacturingOrderCalculationComponent, },
          { path: 'planning', loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-planning/manufacturing-order-planning.component')).ManufacturingOrderPlanningComponent, },
          { path: 'procurement', loadComponent: async () => (await import('./07_feature/manufacturing-order/manufacturing-order-procurement/manufacturing-order-procurement.component')).ManufacturingOrderProcurementComponent, },
        ],
      },
    ],
  },
  {
    path: 'material',
    canActivate: [appRoleGuard],
    canActivateChild: [appRoleGuard],
    loadComponent: async () => (await import('./07_feature/cam-master-tables/cam-master-tables.component')).CamMasterTablesComponent,
  },
  {
    path: 'article',
    canActivate: [articleRoleGuard],
    canActivateChild: [articleRoleGuard],
    children: [
      {
        path: '',
        loadComponent: async () => (await import('./07_feature/article/article.component')).ArticleComponent,
      },
      {
        path: ':articleID',
        loadComponent: async () => (await import('./07_feature/article/article-layout/article-layout.component')).ArticleLayoutComponent,
        children: [
          {
            path: '',
            loadComponent: async () => (await import('./07_feature/article/article-detail/article-detail.component')).ArticleDetailComponent,
          },
          { path: 'basedata', loadComponent: async () => (await import('./07_feature/article/article-base-data/article-base-data')).ArticleBaseData, },
          { path: 'part', loadComponent: async () => (await import('./07_feature/article/article-part/article-part.component')).ArticlePartComponent, },
          { path: 'version', loadComponent: async () => (await import('./07_feature/article/article-version/article-version.component')).ArticleVersionComponent, },
          { path: 'classification', loadComponent: async () => (await import('./07_feature/article/article-classification/article-classification.component')).ArticleClassificationComponent, },
          { path: 'data-acquisition', loadComponent: async () => (await import('./07_feature/article/article-data-acquisition/article-data-acquisition.component')).ArticleDataAcquisitionComponent, },
          { path: 'document', loadComponent: async () => (await import('./07_feature/article/article-document/article-document.component')).ArticleDocumentComponent, },

          { path: 'blank', loadComponent: async () => (await import('./07_feature/article/article-blank/article-blank.component')).ArticleBlankComponent, },
          { path: 'plan', loadComponent: async () => (await import('./07_feature/article/article-plan/article-plan.component')).ArticlePlanComponent, },
          { path: 'calculation', loadComponent: async () => (await import('./07_feature/article/article-calculation/article-calculation.component')).ArticleCalculationComponent, },
          { path: 'issue', loadComponent: async () => (await import('./07_feature/article/article-issue/article-issue.component')).ArticleIssueComponent, },
          { path: 'part-analysis', loadComponent: async () => (await import('./07_feature/part-analysis/part-analysis.component')).PartAnalysisComponent, },
        ],
      },
    ],
  },
  {
    path: 'unauthorized',
    loadComponent: async () => (await import('./07_feature/unauthorized/unauthorized.component')).UnauthorizedComponent,
  },
  // Redirect any other URLs that don’t match
  // (also known as a "wildcard" redirect)
  {path: '**', redirectTo: ''},
];
